import { FC } from "react";

import { UiBreakpoints } from "../../../config/ui/breakpoints";
import { useWindowSize } from "../../../hooks/useWindowSize";
import { Reveal } from "../../Reveal/Reveal";

import { StatCard } from "./StatCard/StatCard";
import { StatGridBlockProps } from "./StatGridBlock.type";

// Mirrors the grid's own breakpoints below. Cards reveal themselves, so scrolling already
// staggers the grid row by row; the delay only has to ripple across the cards of a single
// row, which all cross the viewport edge together. Staggering on the flat item index instead
// would leave every card past the fourth waiting on the same maximum delay.
const columnsAt = (width: number) => {
	if (width >= UiBreakpoints.lg) return 3;
	if (width >= UiBreakpoints.sm) return 2;
	return 1;
};

const StatGridBlock: FC<StatGridBlockProps> = ({ data, id }) => {
	const { items, title } = data;
	const { width } = useWindowSize();
	const columns = columnsAt(width);

	return (
		<div className="flex flex-col gap-4" id={id}>
			{/* Optional: title */}
			{typeof title === "string" && title.trim().length > 0 ? (
				<h3 className="leading-relaxed" dangerouslySetInnerHTML={{ __html: title }} />
			) : null}

			{/* Rows size themselves: a card matches the tallest card in its own row, not the
			    tallest in the grid. `auto-rows-fr` did the latter, which reads as deliberate on a
			    wide screen but strands every card at the tallest one's height once the grid drops
			    to one or two columns. `h-full` down the chain is what still lets a card fill its
			    own row, so the source lines keep their shared bottom edge across that row. */}
			<ul className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
				{items.map((item, index) => (
					<li key={item.id} className="h-full">
						<Reveal className="h-full" index={index % columns}>
							<StatCard item={item} />
						</Reveal>
					</li>
				))}
			</ul>
		</div>
	);
};

export { StatGridBlock };
